class LocalStorageEventManager {

    constructor () {

        this._uuid = (LocalStorageEventManager.LS_MSG_NAME + '_' + parseInt(Math.random() * 1000000000));
        $(window).on('storage', this.onMessageReceive.bind(this));
        Radio.channel('NOTIFICATION').on('LS_MESSAGE:SEND', this.onMessageSend, this);
    }

    onMessageReceive (event) {

        let message = undefined;

        if (event.originalEvent.key !== LocalStorageEventManager.LS_MSG_NAME) {
            return;
        }

        try {
            message = JSON.parse(event.originalEvent.newValue);
        }
        catch (excpt) {
            console.warn('Received invalid message via LS');
        }

        if (message && message.lsManagerUuid && this._uuid !== message.lsManagerUuid) {
            Radio.channel('NOTIFICATION').trigger('LS_MESSAGE:RECEIVED', message.body);
        }
    }

    onMessageSend (message) {

        let msgToSend = {
            body: message,
            timestamp: Date.now(),
            lsManagerUuid: this._uuid
        };

        try {

            localStorage.setItem(LocalStorageEventManager.LS_MSG_NAME, JSON.stringify(msgToSend));
            localStorage.removeItem(LocalStorageEventManager.LS_MSG_NAME);
        } catch (e) {
            console.warn(e);
        }
    }

    static get LS_MSG_NAME () {

        return 'LS_MESSAGE';
    }
}

let lsEventManager = new LocalStorageEventManager();

export {lsEventManager};


// WEBPACK FOOTER //
// ./shared/utils/LocalStorageEventManager.js